import { FC } from 'react';
import { Translate } from '~/i18n';
import { Arrow } from './arrow';

interface PaginationProps {
   totalElements: number;
   currentPage: number;
   lastPage: number;
   numberOfElementsInOnePage: number;
   next: () => void;
   back: () => void;
}

const Pagination: FC<PaginationProps> = ({
   totalElements,
   currentPage,
   lastPage,
   numberOfElementsInOnePage,
   next,
   back,
}) => {
   const numberOfPages: number = Math.ceil(totalElements / numberOfElementsInOnePage);
   return (
      <div className="flex items-center w-full justify-between py-4">
         <div className="flex items-center text-grey-200 text-md">
            <Translate id="common:showing results" /> {currentPage} - {numberOfPages}{' '}
            <Translate id="common:of" /> {numberOfPages}
         </div>
         <div className="flex items-center">
            <button
               disabled={currentPage === 1}
               className="border rounded-full h-6 w-6 flex justify-center items-center bg-grey-200"
               onClick={back}>
               <Arrow className="h-2 [&>*]:text-white !w-2" direction="left" />
            </button>
            <div className="mx-1.5 text-grey-200 text-md">
               {currentPage * numberOfElementsInOnePage - (numberOfElementsInOnePage - 1)} -{' '}
               {totalElements > currentPage * numberOfElementsInOnePage
                  ? currentPage * numberOfElementsInOnePage
                  : totalElements}{' '}
               <Translate id="common:of" /> {totalElements}
            </div>
            <button
               onClick={next}
               className="border rounded-full h-6 w-6 flex justify-center items-center bg-grey-200"
               disabled={currentPage === lastPage}>
               <Arrow className="h-2 [&>*]:text-white !w-2" direction="right" />
            </button>
         </div>
      </div>
   );
};

export default Pagination;
